import { render, staticRenderFns } from "./WorkflowExportCsvModal.vue?vue&type=template&id=b63972fa&scoped=true"
import script from "./WorkflowExportCsvModal.vue?vue&type=script&lang=js"
export * from "./WorkflowExportCsvModal.vue?vue&type=script&lang=js"
import style0 from "./WorkflowExportCsvModal.vue?vue&type=style&index=0&id=b63972fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b63972fa",
  null
  
)

export default component.exports